/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Rows_Per_PageInputs */

const en_table_rows_per_page = /** @type {(inputs: Table_Rows_Per_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rows per page`)
};

const es_table_rows_per_page = /** @type {(inputs: Table_Rows_Per_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filas por pagina`)
};

/**
* | output |
* | --- |
* | "Rows per page" |
*
* @param {Table_Rows_Per_PageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const table_rows_per_page = /** @type {((inputs?: Table_Rows_Per_PageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Rows_Per_PageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_table_rows_per_page(inputs)
	return es_table_rows_per_page(inputs)
});